/* eslint-disable handle-callback-err */

if (navigator.serviceWorker) {
  navigator.serviceWorker
    .register('/swBooking.js')
    .then((registration) => {
      // Registration was successful
      // Perform registration setup if required here
    })
    .catch((err) => {
      // registration failed :(
      // Perform registration failure tasks if required here
    });
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/registerServiceWorker.js